import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';

export namespace PermissionsLockUnlockStyles {
  const permissionsLockUnlockCssPrefix = 'PermissionsLockUnlock';
  export const permissionsLockUnlockHeight = 18;
  export const LockedIcon = 'lock_14px-small.svg';
  export const UnlockedIcon = 'lock_unlocked_14px-small.svg';

  export const ContentContainer = cssClass(permissionsLockUnlockCssPrefix, 'content-container', {
    float: 'left',
    height: `${permissionsLockUnlockHeight}px`,
  });

  export const Label = cssClass(permissionsLockUnlockCssPrefix, 'label', {
    display: 'inline-block',
    lineHeight: `${permissionsLockUnlockHeight}px`,
    verticalAlign: 'middle',
  });

  export const TextLink = cssClass(permissionsLockUnlockCssPrefix, 'text-link', {
    display: 'inline-block',
    marginLeft: `${CommonStyles.Sizes.DefaultSpace}px`,
    verticalAlign: 'middle',
  });

  export const ProgressBar = cssClass(permissionsLockUnlockCssPrefix, 'progress-bar', {
    display: 'inline-block',
  });

  export const ProgressBarBackgroundFill = cssClass(permissionsLockUnlockCssPrefix, 'progress-bar-background-fill', {
    backgroundColor: CommonStyles.Colors.Grey230,
    display: 'inline-block',
    height: '13px',
    marginLeft: TabStyles.Spacing.MediumSpace,
    marginRight: TabStyles.Spacing.MediumSpace,
    minWidth: '170px',
    verticalAlign: '-2.5px',
  });

  export const ProgressBarForegroundFill = cssClass(permissionsLockUnlockCssPrefix, 'progress-bar-foreground-fill', {
    height: '100%',
    backgroundColor: CommonStyles.Colors.ActionOrange,
  });

  export const ProgressNumber = cssClass(permissionsLockUnlockCssPrefix, 'progress-number', {
    color: CommonStyles.Colors.Grey51
  });

  export const StatusIcon = cssClass(permissionsLockUnlockCssPrefix, 'status-icon', {
    marginRight: '8px',
    verticalAlign: 'text-bottom',
  });
}
